import Vue from 'vue'
import Vuex from 'vuex'

import Request, { APIS } from '@/js/Request';
import GetSalesData from '@/js/GetSalesData'

// @ts-ignore
Vue.use(Vuex)

const storageTemplate = {
    other: {
        clickCount: 0,
        todos: []
    }
}

class StateManager {
    constructor() {

        this.localStorage = {};

        try {
            this.localStorage = JSON.parse(window.localStorage.getItem('data')) || {};
        } catch(err) {console.error(err)}

        this.store = new Vuex.Store({
            state: {
                woodShopBoard: {
                    departments: [],
                    sales: [],
                    salestatOptions: {
                        from: new Date(Date.now()),
                        to: new Date(Date.now() - 7 * 24 * 60 * 60)
                    }
                },

                other: this.localStorage.other || storageTemplate.other
            },

            mutations: {
                setDepartments(state, data) {
                    state.woodShopBoard.departments = data;
                },

                setSales(state, data) {
                    state.woodShopBoard.sales = data;
                },

                setSaleOptions(state, data) {

                }
            },

            actions: {
                submitSaleSearch(context, {departmentId, from, to, preset, callback}) {
                    console.log("Submitting sale search");

                    GetSalesData(departmentId, from, to, preset).then(data => {
                        context.commit('setSales', data);

                        if (typeof callback == 'function') callback(data);
                    }).catch(console.error);
                }
            },

            getters: {
                getDepartments: state => {
                    return new Promise((res, rej) => {

                        // If there are no departments, get departments from the API
                        if (state.woodShopBoard.departments.length <= 0) {
                            Request(APIS.Department).then(data => {
                                this.store.commit("setDepartments", data);
                                res(data);
                            }).catch(rej);
                        }
    
                        else {
                            res(state.woodShopBoard.departments);
                        }
                    })
                },
                
                getSales: state => {
                    console.log(state.woodShopBoard.sales)

                    const toReturn = [];

                    state.woodShopBoard.sales.forEach(sale => {
                        toReturn.push(sale);
                    });

                    return toReturn
                }
            }
        });
    }
}

export default new StateManager();


// WEBPACK FOOTER //
// ./src/js/StateManager.js